(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.searchRail = this.querySelector('.th-header-search-rail');
      this.desktopSearchInput = this.querySelector('.th-header-search__input');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.searchRailVisible = true;
      this.lastSearchRailIntentAt = 0;
      this.searchRailToggledAt = 0;
      this.predictiveSearchInstances = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onWheelSearchRailIntent = this.onWheelSearchRailIntent.bind(this);
      this.onTouchStartSearchRailIntent = this.onTouchStartSearchRailIntent.bind(this);
      this.onTouchMoveSearchRailIntent = this.onTouchMoveSearchRailIntent.bind(this);
      this.onKeydownSearchRailIntent = this.onKeydownSearchRailIntent.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('wheel', this.onWheelSearchRailIntent, { passive: true });
      window.addEventListener('touchstart', this.onTouchStartSearchRailIntent, { passive: true });
      window.addEventListener('touchmove', this.onTouchMoveSearchRailIntent, { passive: true });
      window.addEventListener('keydown', this.onKeydownSearchRailIntent);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('wheel', this.onWheelSearchRailIntent);
      window.removeEventListener('touchstart', this.onTouchStartSearchRailIntent);
      window.removeEventListener('touchmove', this.onTouchMoveSearchRailIntent);
      window.removeEventListener('keydown', this.onKeydownSearchRailIntent);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.updateSearchRailOnScroll(scrollTop);

      if (this.isAnyPredictiveSearchOpen() || this.headerIsAlwaysSticky) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (Date.now() - this.searchRailToggledAt < 180) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    updateSearchRailOnScroll(scrollTop) {
      if (!this.searchRail || window.innerWidth < 990) return;

      if (this.isDesktopSearchActive()) {
        this.setSearchRailVisible(true);
        return;
      }

      if (scrollTop <= this.headerBounds.bottom) {
        this.setSearchRailVisible(true);
        return;
      }

      if (Date.now() - this.lastSearchRailIntentAt < 250) return;

      const delta = scrollTop - this.currentScrollTop;
      if (Math.abs(delta) < 24) return;

      this.setSearchRailVisible(delta < 0);
    }

    onWheelSearchRailIntent(event) {
      this.handleSearchRailIntent(event.deltaY);
    }

    onTouchStartSearchRailIntent(event) {
      this.lastTouchY = event.touches?.[0]?.clientY ?? null;
    }

    onTouchMoveSearchRailIntent(event) {
      if (this.lastTouchY === null) return;

      const currentY = event.touches?.[0]?.clientY ?? null;
      if (currentY === null) return;

      this.handleSearchRailIntent(this.lastTouchY - currentY);
      this.lastTouchY = currentY;
    }

    onKeydownSearchRailIntent(event) {
      const downKeys = ['ArrowDown', 'PageDown', 'End', ' '];
      const upKeys = ['ArrowUp', 'PageUp', 'Home'];

      if (downKeys.includes(event.key)) this.handleSearchRailIntent(32);
      if (upKeys.includes(event.key)) this.handleSearchRailIntent(-32);
    }

    handleSearchRailIntent(deltaY) {
      if (!this.searchRail || window.innerWidth < 990 || Math.abs(deltaY) < 4) return;
      if (this.isDesktopSearchActive()) {
        this.setSearchRailVisible(true);
        return;
      }

      this.lastSearchRailIntentAt = Date.now();
      this.setSearchRailVisible(deltaY < 0);
    }

    isDesktopSearchActive() {
      return (
        document.activeElement === this.desktopSearchInput ||
        Array.from(this.predictiveSearchInstances || []).some((predictiveSearch) => predictiveSearch?.isOpen)
      );
    }

    setSearchRailVisible(isVisible) {
      if (!this.searchRail) return;

      if (this.searchRailVisible === isVisible) return;

      this.searchRailVisible = isVisible;
      this.searchRailToggledAt = Date.now();
      this.searchRail.classList.toggle('is-collapsed', !isVisible);
      requestAnimationFrame(this.setHeaderHeight.bind(this));
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }

    isAnyPredictiveSearchOpen() {
      return Array.from(this.predictiveSearchInstances || []).some((predictiveSearch) => predictiveSearch?.isOpen);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
